// infcode_change - new file

export type MigrationItemStatus = "migrated" | "rewritten" | "skipped" | "failed"

export type MigrationSummary = Record<MigrationItemStatus, number>

export type MigrationReport<TItem> = {
  summary: MigrationSummary
  items: TItem[]
}

export function createMigrationReport<TItem>(): MigrationReport<TItem> {
  return {
    summary: {
      migrated: 0,
      rewritten: 0,
      skipped: 0,
      failed: 0,
    },
    items: [],
  }
}

export function addMigrationItem<TItem extends { status: MigrationItemStatus }>(
  report: MigrationReport<TItem>,
  item: TItem,
) {
  report.items.push(item)
  report.summary[item.status]++
}

export type ModuleStatus = "completed" | "failed"

export type ModuleState<TSummary> = {
  status: ModuleStatus
  summary: TSummary
}

export type SessionMigrationStatus = "migrated" | "skipped" | "failed"

export type SessionMigrationSummary = {
  migrated: number
  skipped: number
  failed: number
  degraded: number
  logSkipped: number
}

export type SessionMigrationItem = {
  legacySessionId?: string
  mappedSessionId?: string
  sourcePath: string
  directory?: string
  projectId?: string
  status: SessionMigrationStatus
  reason?: string
  message?: string
  degradedReasons?: string[]
}

export type SessionMigrationReport = {
  summary: SessionMigrationSummary
  items: SessionMigrationItem[]
}

export function createSessionMigrationReport(): SessionMigrationReport {
  return {
    summary: {
      migrated: 0,
      skipped: 0,
      failed: 0,
      degraded: 0,
      logSkipped: 0,
    },
    items: [],
  }
}

export function addSessionMigrationItem(report: SessionMigrationReport, item: SessionMigrationItem) {
  report.items.push(item)
  report.summary[item.status]++
  if ((item.degradedReasons?.length ?? 0) > 0) report.summary.degraded++
}
